<template>
  <div>
    <HeaderNav ref="refLogin" />
    <main>
      <router-view />
    </main>
    <Footer v-if="footer" />
    <div style="position: fixed;right: 0;bottom: 1.25rem;" v-if="showOrder">
      <div class="order" @click="orderBtn">
        <span style="width: .875rem;height: .875rem;background: #002FA7;opacity: 1;border-radius: 50%;">
          <img src="../../assets/newImg/icon_shop.png" alt="" style="margin-top: .2375rem;width: .375rem;height: .3625rem;vertical-align: super;">
        </span>
        <span
          style="line-height: .875rem;font-size: .3rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">{{$t('meg.order')}}</span>
        <span
          style="line-height: .875rem;font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #818AA0;">{{$t('meg.inlet')}}</span>
        <span>
          <img src="../../assets/newImg/icon_enter.png" alt=""
            style="margin-top: .3375rem; margin-right: .1875rem;width: .2375rem;height: .225rem;vertical-align: super;">
        </span>
      </div>
      <div class="order" style="margin-top: .475rem;" @click="facBtn">
        <span style="width: .875rem;height: .875rem;background: #F7B02D;opacity: 1;border-radius: 50%;">
          <img src="../../assets/newImg/icon_factory.png" alt=""  style="margin-top: .2375rem;width: .375rem;height: .3625rem;vertical-align: super;">
        </span>
        <span
          style="line-height: .875rem;font-size: .3rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">{{$t('meg.fac')}}</span>
        <span
          style="line-height: .875rem;font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #818AA0;">{{$t('meg.inlet')}}</span>
        <span>
          <img src="../../assets/newImg/icon_enter.png" alt=""
            style="margin-top: .3375rem; margin-right: .1875rem;width: .2375rem;height: .225rem;vertical-align: super;">
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import HeaderNav from "../../components/nav/headerNav.vue";
import Footer from "../../components/nav/footerNav.vue";
import { selectIsInfo, mangeInfo } from "../../api/order"
import { useRouter, useRoute } from 'vue-router';
import { ref, watch } from "vue";
import { ElMessage } from 'element-plus'
const router = useRouter()
const footer = ref(true)
const showOrder = ref(true)
const refLogin = ref()
const access_token = localStorage.getItem("access_token")



const orderBtn = () => {
  if (access_token) {
    selectIsInfo().then(res => {
      if (res.data.code == 200) {
        router.push("/placeOrder")
      } else {
        ElMessage.error(res.data.msg)
      }
    })
  } else {
    ElMessage.error("您还未登录，请先登录")
    if (refLogin.value) {
      refLogin.value.openModal(); // 通过引用调用子组件的方法
    }
  }
}

const facBtn = () => {
  if (access_token) {
    mangeInfo().then(res => {
      if (res.data.code == 200) {
        router.push("/listOrder")
      } else {
        ElMessage.error(res.data.msg)
      }
    })
  } else {
    ElMessage.error("您还未登录，请先登录")
    if (refLogin.value) {
      refLogin.value.openModal(); // 通过引用调用子组件的方法
    }
  }

}

watch(() => router.currentRoute.value.path, (to) => {
  if (to == "/placeOrder" || to == "/listOrder" || to == "/orderDetail") {
    footer.value = false
    showOrder.value = false
  } else {
    footer.value = true
    showOrder.value = true
  }
}, { immediate: true, deep: true })
</script>

<style scoped>
.order {
  width: 2.8625rem;
  height: .875rem;
  background: #EEEEEE;
  border-radius: 0rem 0rem 0rem 0rem;
  opacity: 1;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: .75rem;
  border-bottom-left-radius: .75rem;
  cursor: pointer;
}

/* ::v-deep .el-carousel__indicator {
  position: absolute;
  bottom: 46px;
  right: 490px;
}  */
</style>
